import React from 'react';


export default function ErrorCross() {
  return (
    <svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<circle cx="202.5" cy="200" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="227.5" cy="225" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="252.5" cy="250" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="277.5" cy="275" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="302.5" cy="300" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="327.5" cy="325" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="352.5" cy="350" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="177.5" cy="225" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="152.5" cy="250" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="127.5" cy="275" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="102.5" cy="300" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="77.5" cy="325" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="52.5" cy="350" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="177.5" cy="175" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="152.5" cy="150" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="127.5" cy="125" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="102.5" cy="100" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="77.5" cy="75" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="52.5" cy="50" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="227.5" cy="175" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="252.5" cy="150" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="277.5" cy="125" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="302.5" cy="100" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="327.5" cy="75" r="7.5" fill="#071013" fillOpacity="0.5"/>
<circle cx="352.5" cy="50" r="7.5" fill="#071013" fillOpacity="0.5"/>
</g>
</svg>

  )
}
